import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, startWith, takeUntil } from 'rxjs/operators';
import { FormConfigService } from 'src/app/form-config/form-config.service';
import { LegalEnum, LegalFormEnum, PricingEnum, ProductCaptureGroupsEnum } from '../../model/enums/product-capture.enums';
import { CountriesOfOffer } from '../../model/interfaces/countries-of-offer.interface';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent {

  @Input()
  public productForm: FormGroup;

  labels = this.formService.getLabels('pricing');

  destroy$ = new Subject<void>();

  fieldToggle = 'pct';

  constructor(private formService: FormConfigService) { }

  ngOnInit(): void {
    this.toggleEconomicField();
    this.selectFieldsCaptureType();
  }

  toggleEconomicField(): void {
    this.countriesOfOffer.valueChanges
      .pipe(
        startWith(this.countriesOfOffer.value),
        takeUntil(this.destroy$),
        debounceTime(100)
      ).subscribe((values: CountriesOfOffer[]) => {
        const hasUSA = values.some((value) => value.jurisdictionsLegal === 'United States of America');
        const economicValueCtrl = this.pricingForm.get(PricingEnum.ECONOMIC_VALUE);
        
        if (hasUSA) {
          economicValueCtrl.enable();
        } else {
          economicValueCtrl.setValue(null);
          economicValueCtrl.disable();
        }
      })
  }

  selectFieldsCaptureType(): void {
    this.tradingInUnits
      .valueChanges
      .pipe(
        startWith(this.tradingInUnits.value),
        takeUntil(this.destroy$),
        debounceTime(100)
      ).subscribe((tradingInUnits: boolean) => {
        this.fieldToggle = tradingInUnits ? 'abs' : 'pct';
      });
  }

  get pricingForm(): FormGroup {
    return this.productForm.get(PricingEnum.PRICING) as FormGroup;
  }

  get legalForm(): FormGroup {
    return this.productForm.get(ProductCaptureGroupsEnum.legalForm) as FormGroup;
  }

  get countriesOfOffer(): FormArray {
    return this.legalForm.get(LegalFormEnum.countriesOfOffer).get('countriesOfOfferArr') as FormArray;
  }

  get tradingInUnits(): FormControl {
    return this.legalForm.get(LegalFormEnum.legal).get(LegalEnum.tradingInUnits) as FormControl;
  }

  get economicValue(): FormControl {
    return this.pricingForm.get(PricingEnum.ECONOMIC_VALUE) as FormControl;
  }

  get fairValue(): FormControl {
    return this.pricingForm.get(PricingEnum.FAIR_VALUE) as FormControl;
  }

  get reofferPrice(): FormControl {
    return this.pricingForm.get(PricingEnum.REOFFER_PRICE) as FormControl;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
